import { FaArrowLeft } from "react-icons/fa";
import { images } from "../../../action/customFn";
import "../../../asset/css/authroot.css";
import GoogleAuthComponent from "../GoogleAuth";
import { MdError } from "react-icons/md";
import { Formik } from "formik";
import { AnimatePresence, motion } from "framer-motion";
import SmallLoader from "../../SmallLoader";
import { Outlet, useNavigate } from "react-router-dom";
import LoginFormNew from "./components/LoginFormNew";

function AuthRootNew() {
  const navigate = useNavigate();
  
  return (
    <div className="authroot-wr" style={{backgroundColor:"#f7f8fe", overflow:"hidden"}}>
      <Outlet />
    </div>
  )
}

export default AuthRootNew
